import { Component, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'uex-no-data',
  templateUrl: './no-data.component.html'
})
export class NoDataComponent {
  @Input('text') text = 'Nenhum registro encontrado.';

  constructor(
    public elementRef: ElementRef
  ) { }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }
}
